import { actionCopyEnUs } from "./actionCopy";

export const authCopyEnUs = {
    backToWebsite: "Back to Website",
    languageLabel: "Language / Sprache / Sprog",
    languageDescription: "Change the app language. Sprache der App ändern. Skift appsprog.",
    chooseLanguage: "Choose language",
    or: "OR",
    next: actionCopyEnUs.next,
    submit: actionCopyEnUs.submit,
    continue: actionCopyEnUs.continue,
    logout: "Logout",
    verifyingAuthentication: "Verifying authentication...",
    signUpSignIn: "Sign up / Sign in",
    signIn: "Sign in",
    signUp: "Sign up",
    signUpWith: (name) => `Sign up with ${name}`,
    joinStudy: (studyName) => `Join ${studyName}`,
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    signInWithPasswordInstead: "Sign in with password instead",
    contactMethodLabel: "Contact method",
    patientRole: "Patient",
    forgotPassword: "Forgot Password",
    confirmYourAccount: "Confirm your account",
    choosePassword: "Choose Password",
    confirmPassword: "Confirm Password",
    showPassword: "Show Password",
    passwordsDontMatch: "Passwords don't match",
    passwordsMatch: "Passwords match",
    passwordAllGood: "All Good!",
    passwordRequirementMinLength: "Must be at least 8 characters long",
    passwordRequirementLowercase: "Must contain a lowercase letter",
    passwordRequirementUppercase: "Must contain an uppercase letter",
    passwordRequirementNumber: "Must contain a number",
    passwordRequirementSpecial: "Must contain a special character",
    setYourPassword: "Set Your Password",
    setPasswordDescription: "Create a secure password for your account",
    settingPassword: "Setting Password...",
    smartAuthHint: "Enter the email or phone number your Patient Watch invitation was sent to.",
    usePhoneInstead: "Use phone instead",
    useEmailInstead: "Use email instead",
    phoneVerificationHint: "We will send a verification code to your phone.",
    phoneSignupHint: "We will send a verification code to your phone. Standard message rates may apply.",
    loggingIn: "Logging in...",
    sendingCode: "Sending code...",
    logIn: "Log in",
    sendCode: "Send code",
    sendVerificationCode: "Send verification code",
    sendingCodeEllipsis: "Sending code…",
    codeSent: "Code sent",
    codeSentToPhone: "Code sent to your phone",
    verificationCodeSent: "Verification code sent",
    emailFallbackCodeSent: "We could not send a text, so we emailed you a code instead.",
    checkFormAndTryAgain: "Please check the form and try again.",
    somethingWentWrong: "Something went wrong. Please try again.",
    newUser: "New user",
    invitationFound: "Invitation found",
    accountFound: "Account found",
    accountFoundUseEmailSmsNotReady:
        "Account found. Sign in with your email. SMS sign-in is not set up for this number on your account yet.",
    smsLoginContactCareTeam:
        "SMS sign-in is not available for this number. Please speak to the team who invited you for help.",
    authMethodError: "Auth method error",
    smsLoginUnavailable:
        "SMS sign-in is not available for this number yet. Sign in with the email on your account instead.",
    email: "Email",
    emailTab: "Email",
    phoneTab: "Phone",
    emailPlaceholder: "e.g. name@company.com",
    password: "Password",
    phone: "Phone number",
    enterEmailAddress: "Enter your email address",
    enterPhoneNumber: "Enter your phone number",
    enterPhoneWithCountryCode: "Enter a phone number including country code.",
    forgotPasswordEmailHint:
        "Enter the email on your account. We will send you a verification code to reset your password.",
    forgotPasswordPhoneHint: "Enter the phone number on your account. We will send a verification code by text.",
    sending: "Sending...",
    backToSignIn: "Back to sign in",
    backToForgotPassword: "Back to forgot password",
    backToConfirmAccount: "Back to confirm account",
    backToSignup: "Back to sign up",
    verifyYourAccount: "Verify your account",
    verifyEmailCodeHint: "Enter the verification code sent to your email address.",
    verifySmsCodeHint: "Enter the code sent to your phone number.",
    verifying: "Verifying…",
    resendCode: "Resend code",
    didNotReceiveCode: "Didn't receive a code?",
    resendConfirmationCode: "Resend Confirmation Code",
    needHelpContact: "Need help? Contact",
    consentTermsPrefix: "I accept the",
    termsOfUse: "Terms of Use",
    consentAnd: "and",
    privacyPolicy: "Privacy Policy",
    selectHospitalLabel: "Which hospital are you under for this care?",
    selectHospitalPlaceholder: "Select your hospital",
    selectHospitalToContinue: "Please select your hospital to continue.",
    ownOrganisationNameLabel: "Organization name",
    ownOrganisationNamePlaceholder: "e.g. City Orthopedic Clinic",
    ownOrganisationNameHint: "This creates your organization on Patient Watch. You can invite colleagues later.",
    organisationNameTooShort: "Please enter an organization name with at least 3 characters.",
    signupSessionExpired: "Your sign-up session expired. Go back and request a new code.",
    loadingSignup: "Loading sign-up…",
    welcomeToPatientWatch: "Welcome to Patient Watch",
    invitedByLine: (name) => `${name} has invited you to join Patient Watch.`,
    welcomeFirstTime: "Welcome - this looks like your first time here.",
    choosePasswordDescription: "Choose a password to finish setting up your account.",
    alreadyHavePasswordSkip: "Skip - I already have a password",
    finishProfileSetup: "Let's finish setting up your profile.",
    continueToProfileSetup: "Continue to profile setup",
    alreadySignedIn: "Already signed in",
    alreadySignedInDescription:
        "Continue to the app, or sign out if you need another account (for example to open an invitation or sign-up link while already signed in).",
    continueToProfile: "Continue",
    continueToApp: "Continue",
    notLoggedInResetPassword: "You are not logged-in, to reset your password please go to:",
    authenticationComplete: "Authentication Complete",
    authenticationCompleteDescription: "You are now logged in, click next to continue.",
    authenticationFailed: "Authentication Failed",
    authenticationFailedDescription: "Link invalid, please try again.",
    noAccountFound: "No account found",
    noAccountForContact: (contact) => `No account for ${contact}`,
    noAccountForDetails: "We couldn't find an account with those details.",
    inviteOnlyPlatform: "Patient Watch is an invite-only platform. Please select your role to continue:",
    iAmPatient: "I am a Patient",
    iAmClinician: "I am a Clinician",
    wrongEmailGoBack: "Typed the wrong email?",
    goBackAndTryAgain: "Go back and try again.",
    noAccountChoosePath:
        "If you are a clinician, you can start free right now. If you are a patient, you need an invitation.",
    noAccountPatientTitle: "Patients",
    noAccountPatientDescription:
        "Patient Watch is invite-only for patients. Ask your clinic to invite you, or get help if you think you already have an invite.",
    noAccountPatientCta: "I need patient help",
    noAccountClinicianTitle: "Clinicians",
    noAccountClinicianDescription:
        "Invite patients, collect outcome scores, and see progress over time - free to start, no card needed. Upgrade only when your caseload grows.",
    noAccountClinicianCta: "Create free account",
    confirmAccountInviteTitle: "You are invited to join Patient Watch",
    couldNotVerifyContact: "We couldn't verify your contact details",
    invitedToJoin: "You are invited to join Patient Watch",
    inviterInvitedYou: (name) => `${name} has invited you.`,
    confirmPhoneInviteBody:
        "Confirm your phone number below. We will text you a verification code so you can finish setting up your account.",
    confirmEmailInviteBody:
        "Confirm your email below. We will send you a verification code so you can finish setting up your account.",
    useInvitationContactDetails: "Use your invitation contact details",
    enterInvitationContactHint: "Enter the email address or phone number your Patient Watch invitation was sent to.",
    enterConfirmationCode: "Enter Confirmation Code",
    processing: "Processing",
    verifyYourEmailTitle: "Verify Your Email",
    verifyEmailIcon: "Verify you Email",
    emailConfirmed: "Email Confirmed",
    emailConfirmedDescription: "You can now proceed to login.",
    verifyEmailWelcome: (firstName) =>
        `Welcome${firstName ? `, ${firstName}` : ""}! We need to verify your email address.`,
    verifyEmailSendHint: "We'll send a 6-digit verification code to this email address.",
    sendingCodeButton: "Sending Code...",
    sendVerificationCodeButton: "Send Verification Code",
    enterVerificationCode: "Enter Verification Code",
    enterCodeSentTo: (email) => `Please enter the code sent to ${email}`,
    checkJunkFolder: "Don't forget to check your junk folder!",
    deleteAccount: "Delete Account",
    deleteAccountReason: "Reason for deleting account",
    troubleAccessingTitle: "Trouble Accessing Patient Watch?",
    patientInviteMismatch: (email) =>
        `If you have received an invitation, please check the email address invited is the same as ${email}.`,
    patientContactProvider:
        "If you believe you should have received an invitation, kindly contact your healthcare provider to confirm your details.",
    contactSupportTeam: "Contact our support team",
    interestedInPwTitle: "Interested in Patient Watch?",
    interestedInPwBody1: "Monitor patient outcomes and stay connected with your practice.",
    signupStarterPlan: "See paid plans",
    carePlanInjection: "Your care plan includes an injection.",
    carePlanInjectionTo: (where, substance, amount) => {
        if (where && substance && amount) return `Injection to ${where}: ${substance} (${amount}).`;
        if (where && substance) return `Injection to ${where}: ${substance}.`;
        if (where && amount) return `Injection to ${where} (${amount}).`;
        if (where) return `Follow-up after an injection to ${where}.`;
        if (substance && amount) return `Injection: ${substance} (${amount}).`;
        if (substance) return `Injection: ${substance}.`;
        return "";
    },
    carePlanSurgery: "Your care plan includes surgery.",
    carePlanSurgeryArea: (area) => `Your care plan includes surgery (${area}).`,
    carePlanShockwave: "Your care plan includes shockwave treatment.",
    authErrorTitle: "Authentication Error",
    linkExpiredTitle: "This link has expired",
    almostThere: "Almost there!",
    preparingAccount: "Just a moment while we prepare your account...",
    verifyEmailCallBody: (email) => `Please enter the code sent to ${email}.\n\nDon't forget to check your junk!`,
    verifyingPhone: "Verifying phone number",
    verifyingEmail: "Verifying email",
    phoneVerified: "Phone verified",
    emailVerified: "Email verified",
    verifyingPhoneWait: "Just a moment while we verify your phone number...",
    verifyingEmailWait: "Just a moment while we verify your email...",
    phoneVerifiedSuccess: "Your phone number has been verified successfully! Let's get your account set up.",
    emailVerifiedSuccess: "Your email has been verified successfully! Let's get your account set up.",
    verifyPhoneError: "Please try verifying your phone number again or contact support@patient-watch.com",
    verifyEmailError: "Please try verifying your email again or contact support@patient-watch.com",
    verificationError: "Verification error",
    tryAgain: "Try Again",
    freemiumSignupTitle: "Create your free account",
    freemiumSignupDescription:
        "Invite patients, collect outcome scores, and follow their recovery - ready in minutes, no card needed.",
    freemiumSignupBenefit1: "Invite patients and collect outcome scores straight away",
    freemiumSignupBenefit2: "Automated reminders keep patients engaged between visits",
    freemiumSignupBenefit3: "See progress over time in a clear clinician dashboard",
    freemiumSignupCta: "Create free account",
    freemiumSignupSubmitting: "Creating account…",
    freemiumSignupUpgradeHint: "Looking for higher volume?",
    freemiumSignupSeePaidPlans: "See other plans",
    diaryInviteUnavailableTitle: "This invite isn't available",
    diaryInviteUnavailableCallout: "No diary was started",
    diaryInviteUnavailableBody: "Another diary can't be added on the current plan.",
    diaryInviteUnavailableNextStep: "Please contact your clinic. They can invite you again once they have capacity.",
    diaryInviteOwnerUnresolvedBody: "We couldn't start this diary. Please ask for a new invite link.",
    mfaEnrollTitle: "Set up authenticator",
    mfaEnrollDescription: "Scan this QR code, then enter the six-digit code from your app.",
    mfaManualSetup: "Cannot scan the QR code?",
    mfaQrCodeAlt: "Authenticator setup QR code",
    mfaChallengeTitle: "Two-factor authentication",
    mfaChallengeDescription: "Enter the six-digit code from your authenticator app.",
    mfaAuthenticatorCode: "Authenticator code",
    mfaVerifyCode: "Verify code",
    mfaVerifying: "Verifying…",
    mfaLoading: "Loading…",
    mfaSettingsTitle: "Authenticator security",
    mfaSettingsDescription: "Your authenticator is required for privileged access.",
    mfaFactorActive: "Authenticator active",
    mfaReplaceFactor: "Replace authenticator",
    mfaReplaceConfirm: "Remove this authenticator and set up a replacement now?",
};
